import { Schema } from "effect";
import { BulkSupportTicketAction } from "../shopper-ai/conversation/bulk-support-ticket-action";

export const SupportTicketBulkActionProgressStatus = Schema.Literal(
  "started",
  "processing",
  "completed",
  "failed",
);
export type SupportTicketBulkActionProgressStatus =
  typeof SupportTicketBulkActionProgressStatus.Type;

export const SupportTicketBulkActionProgressNotification = Schema.Struct({
  _tag: Schema.Literal("bulkSupportTicketActionProgress"),
  workflowId: Schema.String,
  action: BulkSupportTicketAction,
  status: SupportTicketBulkActionProgressStatus,
  totalCount: Schema.Number,
  processedCount: Schema.Number,
  failedCount: Schema.Number,
});
export type SupportTicketBulkActionProgressNotification =
  typeof SupportTicketBulkActionProgressNotification.Type;

export const SupportTicketBulkActionNotification = Schema.Union(
  SupportTicketBulkActionProgressNotification,
);
export type SupportTicketBulkActionNotification =
  typeof SupportTicketBulkActionNotification.Type;
